import { Window } from 'nots-window-renderer/lib';
import QueryString from 'query-string';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';

import videoPanel from '../../definitions/mainScreen/videoPanel.json';
import { ComposedActions } from '../../helpers/actions';
import { LessonState } from '../../helpers/constants';
import {
    executorStatusUpdateAC, startExecutorAC, uiUserSetWindowAttribute_AC, uiWindowBtnClickAC
} from '../../store/actions/executor.actions';
import MultimediaDialog from '../MultimediaDialog';
import Map from './Map';
import sample from './sample.json';
import { WindowsMenu } from './WindowsMenu';

export interface ICatizProps {
  lessonDef: any;
}

const CatizContainer = styled.div`
  width: 100%;
  height: 100%;
  min-width: 1920px;
  min-height: 1080px;
  max-width: 2560px;
  max-height: 1600px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background: ${({ theme }) => theme.player.main.primary};
  color: ${({ theme }) => theme.player.main.color};
  font-size: ${({ theme }) => theme.player.main.fontSize};
  font-family: ${({ theme }) => theme.player.main.fontFamily};
`;

const TopContainer = styled.div`
  display: flex;
  max-height: 10%;
  min-height: 13%;
`;

const TitleContainer = styled.div`
  width: 12%;
  display: inline-block;
  text-align: center;
`;

const AlertPanelContainer = styled.div`
  width: 20%;
  border: 2px groove #8799a4;
  flex: 1;
`;
const VideoPanelContainer = styled.div`
  width: 68%;
  display: inline-block;
  padding: 9px;
`;

const BodyContainer = styled.div`
  display: flex;
  flex-grow: 1;
  min-height: 87%;
`;
const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const HookContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 0px 8px;
  border-left: 1px solid rgb(170, 170, 170);
`;

const HookImageContainer = styled.div`
  text-align: center;
  margin-bottom: 8px;
  > img {
    height: 16px;
    width: 16px;
  }
`;

const PauseIcon = styled(PauseCircleOutlineIcon)`
  position: fixed;
  bottom: 5px;
  right: 5px;
  z-index: 1888;
  cursor: pointer;
  font-size: 30px !important;
`;

const PlayIcon = styled(PlayCircleOutlineIcon)`
  position: fixed;
  bottom: 5px;
  right: 5px;
  z-index: 1888;
  cursor: pointer;
  font-size: 35px !important;
`;

const getConfig = (items: Array<any>, toFind: string): any => {
  return items.find((item) => item.classType === toFind);
};

const buttonDict = videoPanel.buttons.reduce((prev: any, curr: any) => {
  prev[curr.id] = curr;
  return prev;
}, {});
const buttonRows = videoPanel.buttonArrays;

export function Catiz({ lessonDef }: ICatizProps) {
  const executor = useSelector((state: any) => state.executor);
  const resources = useSelector((state: any) => state.resources);
  const history = useHistory();
  const location = useLocation();
  const { mode, role } = QueryString.parse(location.search);
  const [displayWindows, setDisplayWindows] = React.useState<any>({});
  const [windowData, setWindowData] = React.useState<any>({});
  const status = useSelector(
    (state: any) => state.executor && state.executor.status
  );
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (executor.status === LessonState.STOPPED) {
      // history.replace('/main');
    }
    console.log('catiz index executor change', executor);
    setDisplayWindows(executor.displayWindows);
    setWindowData(executor.windows);
  }, [history, executor]);
  React.useEffect(() => {
    window.open(
      `${window.location.origin}/nots/app/nots_player/touchpanel`,
      'touchpanel',
      'width=1030,height=650'
    );
  }, []);

  const pauseLesson = (doPause: boolean) => {
    dispatch(
      executorStatusUpdateAC(doPause ? LessonState.PAUSED : LessonState.STARTED)
    );
  };

  const onFieldUpdate = (windowId: string, key: string, value: any) => {
    dispatch(uiUserSetWindowAttribute_AC(windowId, key, value));
  };

  const onButtonClick = (windowId: string, key: string) => {
    dispatch(
      ComposedActions.PushWindowButton.aCreator({
        windowId,
        buttonId: key,
      })
    );
    // dispatch(uiWindowBtnClickAC(windowId, key));
  };
  React.useEffect(() => {
    (async () => {
      dispatch(
        startExecutorAC(lessonDef, {
          role: role,
          lang: 'en',
          mode: mode || 'demo',
        })
      );
    })();
  }, [lessonDef, dispatch]);

  return (
    <Container>
      {status === LessonState.STARTED ? (
        <PauseIcon onClick={() => pauseLesson(true)} />
      ) : (
        <PlayIcon onClick={() => pauseLesson(false)} />
      )}
      <CatizContainer>
        {Object.keys(displayWindows)
          .map((dWindow) => displayWindows[dWindow])
          .filter((dWindow) => dWindow.visible)
          .map((dWindow) => {
            console.log('catiz index sending data', windowData[dWindow.window]);
            return (
              <Window
                key={dWindow.window}
                defaultValues={windowData[dWindow.window]}
                values={windowData[dWindow.window]}
                window={{
                  ...resources[dWindow.window],
                  ...displayWindows[dWindow.window],
                }}
                // window={sample}
                onFieldUpdate={(key, value) =>
                  onFieldUpdate(dWindow.window, key, value)
                }
                onButtonClick={(key: string) =>
                  onButtonClick(dWindow.window, key)
                }
              />
            );
          })}
        <TopContainer>
          <TitleContainer>
            <div>CATIZ</div>
            <div>Combat System</div>
          </TitleContainer>
          <AlertPanelContainer></AlertPanelContainer>
          <VideoPanelContainer>
            <WindowsMenu
              panelRows={buttonRows}
              buttonDict={buttonDict}
            ></WindowsMenu>
          </VideoPanelContainer>
        </TopContainer>
        <BodyContainer>
          <Map></Map>
          <HookContainer>
            <HookImageContainer>
              <img src={require('../../assets/images/primaryHookIcon.png')} />
            </HookImageContainer>
          </HookContainer>
          <HookContainer>
            <HookImageContainer>
              <img src={require('../../assets/images/secondaryHookIcon.png')} />
            </HookImageContainer>
          </HookContainer>
          <MultimediaDialog />
        </BodyContainer>
      </CatizContainer>
    </Container>
  );
}
